export class DialogJustificationModel {
    constructor(
        public title: string,
        public maxLength: number,
        public content?: string,
        public saveButtonLabel: string = 'Confirmar',
        public rows: number = 2,
    ) { }
}
